//import $ from 'jquery';
import {HEADER_SELECTOR} from '../constants';

const
  NAME               = 'anchorDisplacement',
  VERSION            = '1.0.0',
  JQUERY_NO_CONFLICT = $.fn[NAME],
  ANIMATION_SPEED    = 1000
;

class AnchorDisplacement {
  constructor(element$) {
    this.hash = element$[0].hash.slice(1);

    if (this.hash) {
      this.target$ = $(`[name='${this.hash}']`);
      if (this.target$.length) {
        element$.on('click', this.onClick.bind(this));
      }
    }
  }

  onClick(/*event*/) {
    var headerHeight = 0;
    $(HEADER_SELECTOR).children().each(function() {
        headerHeight = headerHeight + $(this).height();
    });

    $('html, body').animate({
      scrollTop: this.target$.offset().top - headerHeight
    }, ANIMATION_SPEED);
  }

  static get VERSION() {
    return VERSION;
  }

  static _jQueryInterface(options) {
    return this.each(function() {
      new AnchorDisplacement($(this), options);
    });
  }
}

$.fn[NAME]             = AnchorDisplacement._jQueryInterface;
$.fn[NAME].Constructor = AnchorDisplacement;
$.fn[NAME].noConflict  = function noConflict() {
  $.fn[NAME] = JQUERY_NO_CONFLICT;
  return AnchorDisplacement._jQueryInterface;
};

export default AnchorDisplacement;



// WEBPACK FOOTER //
// ./src/plugins/anchor-displacement.js